<template>
  <span class="integration-related">
    <router-link v-if="to" :to="to">{{ label }}</router-link>
    <span v-else tabindex="0" v-tooltip="tip(reason)">
      {{ label }}
      <span class="integration-muted">— {{ reason }}</span>
    </span>
  </span>
</template>

<script>
import { allowsAccess } from '@/utils/permissionAccess'
import { relatedRoute, tooltip } from './model'
export default {
  props: { object: { type: Object, required: true } },
  computed: {
    to() {
      const can = this.$store.getters['permissions/can']
      return relatedRoute(this.$router, this.object, this.$store.state.userGroups || [], access => allowsAccess(access, this.$store.state.userData, can))
    },
    label() { return `${this.object.label || this.object.type} · ${this.object.type} #${this.object.id}` },
    reason() { return this.object.unavailable_reason || 'This record has no available detail page.' }
  },
  methods: { tip: tooltip }
}
</script>
